<template>
    <div class="animated fadeIn catalog-page">
        <div>
            <b-row v-if="loading">
                <b-col md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-if="!loading">
            <b-row>
                <b-col cols="12" md="4" class="mb-3 mb-md-0">
                    <b-card
                        class="card-wrap catalog-panel-card"
                    >
                        <div slot="header">
                            <span data-font="22">Catalog</span>
                        </div>

                        <div class="catalog-tree-container">
                            <a-tree
                                v-if="treeData.length > 0"
                                :checkable="checkable"
                                v-model="checkedKeys"
                                @select="onSelect"
                                :load-data="onLoadData"
                                :treeData="treeData"
                            />
                        </div>
                    </b-card>
                </b-col>
                <b-col cols="12" md="8" v-if="selectedCatalogObject">
                    <b-card
                        class="card-wrap catalog-panel-card"
                    >
                        <div slot="header">
                            <b-row class="align-items-center">
                                <!-- TITLE -->
                                <b-col cols="12" md="4">
                                    <span data-font="22">Catalog Details</span>
                                </b-col>

                                <!-- BUTTONS GROUP -->
                                <b-col
                                    cols="12"
                                    md="8"
                                    class="catalog-buttons-group"
                                >
                                    <!-- Create Catalog -->
                                    <button
                                        class="btn catalog-action-btn catalog-action-btn--primary mr-2 mb-2"
                                        :disabled="iscreateButtonDisable"
                                        v-if="
                                            userPermission.hasOwnProperty(
                                                'CREATE_CATALOG',
                                            )
                                        "
                                        @click="
                                            $router.push({
                                                path: '/catalog/create',
                                            })
                                        "
                                    >
                                        <span class="font-weight-bold"
                                            >Create Catalog</span
                                        >
                                    </button>

                                    <!-- Details -->
                                    <button
                                        class="btn catalog-action-btn catalog-action-btn--secondary mr-2 mb-2"
                                        v-if="
                                            userPermission.hasOwnProperty(
                                                'CATALOG_DETAIL',
                                            )
                                        "
                                        @click="catalogDetails"
                                    >
                                        <span class="font-weight-bold"
                                            >Details</span
                                        >
                                    </button>

                                    <!-- Delete Catalog -->
                                    <button
                                        class="btn catalog-action-btn catalog-action-btn--danger mr-2 mb-2"
                                        :disabled="iscreateButtonDisable"
                                        v-if="
                                            userPermission.hasOwnProperty(
                                                'DELETE_CATALOG',
                                            ) && !iscreateButtonDisable
                                        "
                                        @click="deleteCatalog"
                                    >
                                        <span class="font-weight-bold"
                                            >Delete Catalog</span
                                        >
                                    </button>
                                </b-col>
                            </b-row>
                        </div>

                        <b-row class="font-md p-2">
                            <b-col cols="12" sm="4" class="mb-2 mb-sm-0">
                                <span>Name</span>
                            </b-col>
                            <b-col cols="12" sm="8">
                                <input
                                    class="form-control"
                                    :disabled="disabled"
                                    :value="selectedCatalogObject.name"
                                />
                            </b-col>
                        </b-row>

                        <b-row class="font-md p-2">
                            <b-col cols="12" sm="4" class="mb-2 mb-sm-0">
                                <span>Catalog Type</span>
                            </b-col>
                            <b-col cols="12" sm="8">
                                <input
                                    class="form-control"
                                    :disabled="disabled"
                                    :value="selectedCatalogObject.catalogType"
                                />
                            </b-col>
                        </b-row>

                        <b-row class="font-md p-2">
                            <b-col cols="12" sm="4" class="mb-2 mb-sm-0">
                                <span>Display Name</span>
                            </b-col>
                            <b-col cols="12" sm="8">
                                <input
                                    class="form-control"
                                    :disabled="disabled"
                                    :value="
                                        selectedCatalogObject.catalogDescription
                                            ?.displayName || ''
                                    "
                                />
                            </b-col>
                        </b-row>

                        <b-row class="font-md p-2">
                            <b-col cols="12" sm="4" class="mb-2 mb-sm-0">
                                <span>Long Description</span>
                            </b-col>
                            <b-col cols="12" sm="8">
                                <input
                                    class="form-control"
                                    :disabled="disabled"
                                    :value="
                                        selectedCatalogObject.catalogDescription
                                            ?.longDescription || ''
                                    "
                                />
                            </b-col>
                        </b-row>

                        <b-row class="font-md p-2">
                            <b-col cols="12" sm="4" class="mb-2 mb-sm-0">
                                <span>Short Description</span>
                            </b-col>
                            <b-col cols="12" sm="8">
                                <input
                                    class="form-control"
                                    :disabled="disabled"
                                    :value="
                                        selectedCatalogObject.catalogDescription
                                            ?.shortDescription || ''
                                    "
                                />
                            </b-col>
                        </b-row>

                        <b-row class="font-md p-2">
                            <b-col cols="12" sm="4" class="mb-2 mb-sm-0">
                                <span>Attribute Count</span>
                            </b-col>
                            <b-col cols="12" sm="8">
                                <input
                                    class="form-control"
                                    :disabled="disabled"
                                    :value="
                                        (
                                            selectedCatalogObject.externalAttributes ||
                                            []
                                        ).length
                                    "
                                />
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";

const getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
            if (node.children.some((item) => item.key === key)) {
                parentKey = node.key;
            } else if (getParentKey(key, node.children)) {
                parentKey = getParentKey(key, node.children);
            }
        }
    }
    return parentKey;
};

export default {
    name: "Catalog",
    components: {
        AtomSpinner,
    },
    data: () => {
        return {
            loading: false,
            iscreateButtonDisable: false,
            expandedKeys: [],
            autoExpandParent: true,
            checkedKeys: [],
            treeData: [],
            disabled: true,
            checkable: false,
            selectedCatalogObject: {
                catalogDescription: {
                    displayName: "",
                    longDescription: "",
                    shortDescription: "",
                },
                externalAttributes: [],
            },
        };
    },
    methods: {
        onLoadData(event) {
            return new Promise((resolve) => {
                if (event.dataRef.children.length > 0) {
                    resolve();
                    return;
                } else {
                    if (!event.dataRef.isProductType) {
                        let searchString = event.dataRef.isRoot
                            ? `isDomain=y&parent=${event.dataRef._id}`
                            : `parent=${event.dataRef._id}`;
                        this.$store
                            .dispatch("catalog/fetchCatalogList", searchString)
                            .then((result) => {
                                if (result.data.status === 1) {
                                    const dataArray = result.data.response;
                                    if (dataArray && dataArray.length > 0) {
                                        dataArray.map((obj) => {
                                            event.dataRef.children.push({
                                                ...obj,
                                                title: obj.name,
                                                key: obj._id,
                                                children: [],
                                                isLeaf: obj.isProductType,
                                            });
                                        });
                                        this.$store.dispatch(
                                            "catalog/updateCatalogTree",
                                            this.treeData,
                                        );
                                    }
                                }
                                resolve();
                            });
                    }
                }
            });
        },
        async generateTree() {
            this.loading = true;
            // it prepares a node structure necessary to render a tree view
            const makeNode = (catalog) => ({
                title: catalog.name,
                key: catalog._id,
                children: [],
                ...catalog,
            });
            // if updated tree available in vuex
            if (this.generatedTreeData.length > 0) {
                this.treeData = this.generatedTreeData;
            } else {
                let searchString = "isRoot=y";
                this.$store
                    .dispatch("catalog/fetchCatalogList", searchString)
                    .then((result) => {
                        if (result.data.status === 1) {
                            const dataArray = result.data.response;
                            if (dataArray && dataArray.length > 0) {
                                let rootCatalog = makeNode(dataArray[0]);
                                this.treeData = [];
                                this.treeData = [rootCatalog];
                                this.$store.dispatch(
                                    "catalog/updateCatalogTree",
                                    this.treeData,
                                );
                            }
                        }
                    });
            }
            this.loading = false;
        },
        async onSelect(event, data) {
            const nodeRef = data.node.dataRef;
            const catalogId = nodeRef._id;

            // Set basic info immediately for responsive UI
            this.selectedCatalogObject = {
                ...nodeRef,
                catalogDescription: nodeRef.catalogDescription || {
                    displayName: "",
                    longDescription: "",
                    shortDescription: "",
                },
                externalAttributes: nodeRef.externalAttributes || [],
            };
            this.selectedCatalogObject.catalogType = nodeRef.isCategory
                ? "Catalog layer"
                : nodeRef.isDomain
                  ? "Domain layer"
                  : nodeRef.isMarket
                    ? "Market layer"
                    : nodeRef.isProductType
                      ? "Product layer"
                      : nodeRef.isRoot
                        ? "Root layer"
                        : "";

            // Fetch full catalog details
            try {
                const result = await this.$store.dispatch(
                    "catalog/fetchCatalogById",
                    catalogId,
                );
                if (result && result.status !== 0 && result.response) {
                    const fullCatalog = result.response;
                    this.selectedCatalogObject = {
                        ...fullCatalog,
                        catalogType: this.selectedCatalogObject.catalogType,
                        catalogDescription: fullCatalog.catalogDescription || {
                            displayName: "",
                            longDescription: "",
                            shortDescription: "",
                        },
                        externalAttributes:
                            fullCatalog.externalAttributes || [],
                    };
                }
            } catch (error) {
                console.error("Failed to fetch catalog details:", error);
            }
        },
        deleteCatalog() {
            if (!this.selectedCatalogObject._id) {
                let errMessage = "Please select catalog...";
                this.$swal({
                    title: "Sorry",
                    text: errMessage,
                    type: "error",
                });
            } else {
                this.$swal({
                    title: "Delete this Catalog?",
                    text: "Are you sure? You won't be able to revert this!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes, Delete it!",
                    cancelButtonColor: "#d33",
                    reverseButtons: true,
                }).then((result) => {
                    if (result.value) {
                        const payload = {
                            catalogId: this.selectedCatalogObject._id,
                        };
                        this.$store
                            .dispatch("catalog/deleteCatalog", payload)
                            .then((result) => {
                                this.$toasted.success(
                                    "Catalog Deleted Successfully",
                                );
                                window.location.reload();
                            });
                    }
                });
            }
        },
        catalogDetails() {
            if (!this.selectedCatalogObject._id) {
                let errMessage = "Please select catalog...";
                this.$swal({
                    title: "Sorry",
                    text: errMessage,
                    type: "error",
                });
            } else {
                this.$router.push({
                    name: "CatalogDetails",
                    params: { id: this.selectedCatalogObject._id },
                });
            }
        },
    },
    mounted: async function () {
        this.generateTree();
    },
    computed: {
        ...mapGetters({
            generatedTreeData: "catalog/GetGeneratedCatalog",
        }),
        userPermission() {
            return this.$store.getters["auth/getUserPermissions"];
        },
    },
};
</script>
<style scoped>
.catalog-page {
    padding-bottom: 0.5rem;
}

.catalog-action-btn {
    min-width: 142px;
    min-height: 44px;
    padding: 0.625rem 1.125rem;
    border-radius: 12px !important;
    font-weight: 700;
    letter-spacing: -0.01em;
}

.catalog-action-btn--primary {
    color: #fff !important;
    background-color: var(--primary) !important;
    border-color: transparent !important;
    box-shadow: 0 14px 28px -20px var(--primary-shadow-strong);
}

.catalog-action-btn--primary:hover,
.catalog-action-btn--primary:focus {
    color: #fff !important;
    background-color: var(--tertiary) !important;
    border-color: transparent !important;
    box-shadow: 0 18px 34px -22px var(--primary-shadow-strong);
}

.catalog-action-btn--secondary {
    color: var(--primary) !important;
    background: rgba(var(--primary-rgb), 0.1) !important;
    border-color: rgba(var(--primary-rgb), 0.14) !important;
    box-shadow: none;
}

.catalog-action-btn--secondary:hover,
.catalog-action-btn--secondary:focus {
    color: var(--tertiary) !important;
    background: rgba(var(--primary-rgb), 0.16) !important;
    border-color: rgba(var(--primary-rgb), 0.18) !important;
}

.catalog-action-btn--danger {
    color: var(--danger-text) !important;
    background: rgba(239, 68, 68, 0.12) !important;
    border-color: rgba(239, 68, 68, 0.16) !important;
    box-shadow: none;
}

.catalog-action-btn--danger:hover,
.catalog-action-btn--danger:focus {
    color: var(--danger-text) !important;
    background: rgba(239, 68, 68, 0.18) !important;
    border-color: rgba(239, 68, 68, 0.22) !important;
}

.catalog-action-btn:disabled {
    color: var(--slate-400) !important;
    background: var(--slate-100) !important;
    border-color: var(--slate-200) !important;
    box-shadow: none !important;
}

::v-deep .catalog-panel-card {
    border: 1px solid var(--border-subtle) !important;
    border-radius: var(--radius-md) !important;
    box-shadow: var(--shadow-sm) !important;
    overflow: hidden;
    background: var(--surface-elevated);
}

::v-deep .catalog-panel-card > .card-body {
    background:
        linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.98) 0%,
            rgba(var(--primary-rgb), 0.03) 100%
        );
}

::v-deep .catalog-panel-card > .card-header,
::v-deep .catalog-panel-card > .card-header.bg-primary,
::v-deep .catalog-panel-card > .card-header.text-white {
    padding: 1.125rem 1.5rem;
    background: #e7edf5 !important;
    border-bottom: 1px solid var(--border-subtle) !important;
    color: var(--text-strong) !important;
}

::v-deep .catalog-panel-card > .card-header span[data-font="22"] {
    color: var(--text-strong) !important;
    font-weight: 700;
    letter-spacing: -0.02em;
}

::v-deep .catalog-panel-card .form-control:disabled,
::v-deep .catalog-panel-card .form-control[readonly] {
    color: var(--text-strong) !important;
    background: var(--surface-soft) !important;
    border-color: var(--border-subtle) !important;
    box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.03);
}

::v-deep .catalog-panel-card .ant-tree li .ant-tree-node-content-wrapper {
    border-radius: 8px;
    color: var(--text-muted);
    transition:
        background-color 0.18s ease,
        color 0.18s ease;
}

::v-deep .catalog-panel-card .ant-tree-switcher,
::v-deep .catalog-panel-card .ant-tree-switcher-icon {
    color: var(--primary);
}

::v-deep .catalog-panel-card .ant-tree li .ant-tree-node-content-wrapper:hover {
    background: rgba(var(--primary-rgb), 0.08);
    color: var(--text-strong);
}

::v-deep
    .catalog-panel-card
    .ant-tree
    li
    .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background: rgba(var(--primary-rgb), 0.14);
    color: var(--primary);
}

.fa-plus {
    border-top-right-radius: 10px;
    border-top-left-radius: 17px;
    border-bottom-left-radius: 17px;
    background-color: #f0f3f5;
}

.catalog-buttons-group {
    display: flex;
    flex-wrap: nowrap;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.catalog-buttons-group .catalog-action-btn {
    margin-right: 0 !important;
    margin-bottom: 0 !important;
    flex: 0 0 auto;
}

@media (min-width: 768px) {
    .catalog-buttons-group {
        justify-content: flex-end;
        margin-top: 0;
    }
}
.catalog-tree-container {
    max-height: 440px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 5px;
}

@media (max-width: 767.98px) {
    .catalog-action-btn {
        width: 100%;
        justify-content: center;
    }

    .catalog-buttons-group {
        flex-wrap: wrap;
        gap: 0.25rem;
    }
}
</style>
